/** `fitb` names a fill-in-the-blank question's single dropdown_text body mount. */
export type QuestionRegionKind = 'prompt' | 'stem' | 'fitb';

/** The grammar is frozen by the anchor model (persisted from part-4 on); do not vary it. */
export function buildQuestionRegionId(questionId: string, kind: QuestionRegionKind): string {
  return `question:${questionId}:${kind}`;
}

/** One region per answer option, named by its domain id; same frozen grammar. */
export function buildQuestionOptionRegionId(questionId: string, optionId: string): string {
  return `question:${questionId}:option:${optionId}`;
}
